/**
 * Quote group id rules for combined / multi-contract saves (parity with GenerateQuoteModal.savePriceAndQuoteAPI).
 * Single SR pack without battery uses empty quote group id at save time.
 */
export type OpportunityInterestFlags = {
    Battery?: boolean;
    RRR?: boolean;
    RR?: boolean;
};

export function effectiveQuoteGroupIdForSrPack(
    productType: string,
    opportunityInterest: OpportunityInterestFlags,
    quoteGroupId: string | number | null | undefined,
): string | number | null | undefined {
    if (productType === 'SR' && !opportunityInterest?.Battery) {
        return '';
    }
    return quoteGroupId;
}
